import axios from 'axios';

const PLATFORM_DOMAIN = (process.env.REACT_APP_PLATFORM_DOMAIN || '').toLowerCase();
const RESERVED_SEGMENTS = ['auth', 'app', 'admin', 'api', 'staff', 'preview', 'staff-portal', 'finance', 'deposit-return'];

const getTenantSlug = () => {
  const path = window.location.pathname;
  // Accept both /<slug>/... AND /<slug> (no trailing slash) so the auth
  // page, the player home, and any deep player route all attach the
  // X-Tenant-Slug header.
  const match = path.match(/^\/([a-z0-9-]+)(\/|$)/i);
  if (match && !RESERVED_SEGMENTS.includes(match[1])) return match[1];
  const host = window.location.hostname || '';
  const parts = host.split('.').filter(Boolean);
  if (PLATFORM_DOMAIN && parts.length >= 3 && parts.slice(-2).join('.') === PLATFORM_DOMAIN) {
    const subdomain = parts[0].toLowerCase();
    if (!['www', 'api', 'admin'].includes(subdomain)) return subdomain;
  }
  return null;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const tenantSlug = getTenantSlug();
  if (tenantSlug) config.headers['X-Tenant-Slug'] = tenantSlug;
  // Auto-generate idempotency key for POST requests
  if (config.method === 'post' && !config.headers['X-Idempotency-Key']) {
    config.headers['X-Idempotency-Key'] = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Normalize error message: backend can return either {detail: "..."} or contract envelope {message: "...", code: "..."}
    if (error.response?.data) {
      const d = error.response.data;
      if (!d.detail && d.message) d.detail = d.message;
    }
    if (error.response?.status === 401) {
      localStorage.removeItem('session_token');
      const path = window.location.pathname;
      const isProtected = path.startsWith('/app') || path.startsWith('/admin') || path.match(/^\/[^/]+\/(app|admin)/);
      if (isProtected) {
        const slug = getTenantSlug();
        const adminPath = path.startsWith('/admin') || Boolean(path.match(/^\/[^/]+\/admin/));
        if (adminPath) {
          window.location.href = slug ? `/${slug}/admin/auth` : '/admin/auth';
        } else {
          window.location.href = slug ? `/${slug}/auth` : '/auth';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
